import React, { useState, } from 'react';
import FlIntegrationService from '../../../service/FlIntegrationService';

const FlDmvRetryForm = ({ loading, onSubmit, onReset, }) => {
  const [transactionId, setTransactionId] = useState('');
  const [fetching, setFetching] = useState(false);
  const [renewal, setRenewal] = useState(null);
  const [fetchError, setFetchError] = useState(null);

  const handleLookup = () => {
    if (!transactionId.trim()) return;
    setFetching(true);
    setRenewal(null);
    setFetchError(null);

    FlIntegrationService.getRenewalByTransactionId(transactionId.trim())
      .then((response) => {
        setRenewal(response.data);
      })
      .catch((err) => {
        setFetchError(err.response?.data || err.message);
      })
      .finally(() => {
        setFetching(false);
      });
  };

  const resetState = () => {
    setRenewal(null);
    setFetchError(null);
    onReset?.();
  };

  const handleRetry = () => {
    onSubmit({ txnId: transactionId.trim(), });
  };

  if (renewal) {
    const isSuccess = renewal.status >= 200 && renewal.status < 300;
    const canRetry = isSuccess && renewal.body?.failedByFlorida === true;

    return (
      <div className='mt-3'>
        <p><strong>Status:</strong> <code>{renewal.status}</code></p>
        <pre className='p-3' style={{ background: '#f5f5f5', maxHeight: '400px', overflow: 'auto', }}>
          {JSON.stringify(renewal.body, null, 2)}
        </pre>
        {isSuccess && !canRetry && (
          <div className='alert alert-warning mt-2'>
            <strong>Cannot retry.</strong> <code>failedByFlorida</code> is <code>false</code>.
            This must be manually set to <code>true</code> before retrying.
          </div>
        )}
        <div className='d-flex justify-content-between align-items-center mt-3'>
          <div>
            {canRetry && (
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleRetry}
                disabled={loading}
              >
                {loading ? 'Retrying...' : 'Proceed with Retry'}
              </button>
            )}
          </div>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={resetState}
          >
            Search Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='mt-3'>
      <div className='mb-3'>
        <label htmlFor='transactionId'>Transaction ID</label>
        <input
          id='transactionId'
          type='text'
          className='form-control'
          placeholder='Enter transaction ID'
          value={transactionId}
          onChange={(e) => setTransactionId(e.target.value)}
          disabled={fetching}
        />
      </div>
      {fetchError && (
        <div className='alert alert-danger mt-2'>
          {typeof fetchError === 'string' ? fetchError : JSON.stringify(fetchError, null, 2)}
        </div>
      )}
      <button
        type='button'
        className='btn btn-primary'
        onClick={handleLookup}
        disabled={!transactionId.trim() || fetching}
      >
        {fetching ? 'Looking up...' : 'Look Up Renewal'}
      </button>
    </div>
  );
};

export default FlDmvRetryForm;
